import { useSearchParams } from 'react-router-dom';

export type Locale = 'it' | 'en';

const translations = {
  // SocialMediaSetupRoute
  'setup.title': {
    it: 'Connetti i Tuoi Social Media',
    en: 'Connect Your Social Media',
  },
  'setup.subtitle': {
    it: 'Collega il tuo account Facebook e Instagram per gestire i tuoi contenuti.',
    en: 'Connect your Facebook and Instagram account to manage your content.',
  },
  'setup.loading': {
    it: 'Caricamento...',
    en: 'Loading...',
  },
  'setup.selectPage.title': {
    it: 'Seleziona la Tua Pagina Facebook',
    en: 'Select Your Facebook Page',
  },
  'setup.selectPage.subtitle': {
    it: 'connessa al tuo account. Seleziona quale pagina vuoi usare per questo cliente.',
    en: 'connected to your account. Select which page you want to use for this client.',
  },
  'setup.selectPage.page': {
    it: 'pagina',
    en: 'page',
  },
  'setup.selectPage.pages': {
    it: 'pagine',
    en: 'pages',
  },
  'setup.selectPage.connecting': {
    it: 'Connessione in corso...',
    en: 'Connecting...',
  },
  'setup.selectPage.confirm': {
    it: 'Conferma Selezione',
    en: 'Confirm Selection',
  },
  'setup.selectPage.error': {
    it: 'Seleziona una pagina',
    en: 'Select a page',
  },
  'setup.meta.title': {
    it: 'Facebook e Instagram',
    en: 'Facebook and Instagram',
  },
  'setup.meta.notConnected': {
    it: 'Non connesso',
    en: 'Not connected',
  },
  'setup.meta.connecting': {
    it: 'Connessione...',
    en: 'Connecting...',
  },
  'setup.meta.connectFacebook': {
    it: 'Connetti Facebook',
    en: 'Connect Facebook',
  },
  'setup.meta.connected': {
    it: 'Connesso',
    en: 'Connected',
  },
  'setup.meta.disconnecting': {
    it: 'Disconnessione...',
    en: 'Disconnecting...',
  },
  'setup.meta.disconnect': {
    it: 'Disconnetti',
    en: 'Disconnect',
  },
  'setup.instagram.notConnected': {
    it: 'Instagram non ancora connesso',
    en: 'Instagram not yet connected',
  },
  'setup.instagram.connecting': {
    it: 'Connessione...',
    en: 'Connecting...',
  },
  'setup.instagram.connect': {
    it: 'Connetti Instagram',
    en: 'Connect Instagram',
  },
  'setup.instagram.retry': {
    it: 'Riprova',
    en: 'Retry',
  },
  'setup.skipInstagram': {
    it: 'Continua senza Instagram',
    en: 'Continue without Instagram',
  },
  'setup.goToApproval': {
    it: "Vai all'Approvazione",
    en: 'Go to Dashboard',
  },
  'setup.help.title': {
    it: 'Perch\u00e9 devo connettere Facebook e Instagram?',
    en: 'Why do I need to connect Facebook and Instagram?',
  },
  'setup.help.body': {
    it: "Connettendo i tuoi account, possiamo pubblicare contenuti automaticamente per te. Non condivideremo mai le tue informazioni e puoi revocare l'accesso in qualsiasi momento.",
    en: 'By connecting your accounts, we can automatically publish content for you. We will never share your information and you can revoke access at any time.',
  },
  'setup.disconnect.metaTitle': {
    it: 'Disconnetti Facebook e Instagram',
    en: 'Disconnect Facebook and Instagram',
  },
  'setup.disconnect.tiktokTitle': {
    it: 'Disconnetti TikTok',
    en: 'Disconnect TikTok',
  },
  'setup.disconnect.metaMessage': {
    it: 'Sei sicuro di voler disconnettere Facebook e Instagram? Dovrai ricollegare entrambi gli account per pubblicare contenuti.',
    en: 'Are you sure you want to disconnect Facebook and Instagram? You will need to reconnect both accounts to publish content.',
  },
  'setup.disconnect.tiktokMessage': {
    it: 'Sei sicuro di voler disconnettere TikTok? Dovrai ricollegare il tuo account per visualizzare le statistiche.',
    en: 'Are you sure you want to disconnect TikTok? You will need to reconnect your account to view statistics.',
  },
  'setup.disconnect.confirm': {
    it: 'Disconnetti',
    en: 'Disconnect',
  },

  // Error messages
  'error.loadStatus': {
    it: 'Impossibile caricare lo stato della connessione',
    en: 'Unable to load connection status',
  },
  'error.oauth_failed': {
    it: 'Autorizzazione Facebook fallita. Riprova.',
    en: 'Facebook authorization failed. Please try again.',
  },
  'error.invalid_state': {
    it: 'Errore di sicurezza. Riprova la connessione.',
    en: 'Security error. Please try the connection again.',
  },
  'error.no_pages': {
    it: 'Non hai pagine Facebook da gestire. Crea una pagina prima di continuare.',
    en: 'You have no Facebook pages to manage. Create a page before continuing.',
  },
  'error.token_exchange_failed': {
    it: 'Errore nella connessione. Riprova tra qualche minuto.',
    en: 'Connection error. Please try again in a few minutes.',
  },
  'error.tiktok_oauth_failed': {
    it: 'Autorizzazione TikTok fallita. Riprova.',
    en: 'TikTok authorization failed. Please try again.',
  },
  'error.tiktok_token_exchange_failed': {
    it: 'Errore nella connessione TikTok. Riprova tra qualche minuto.',
    en: 'TikTok connection error. Please try again in a few minutes.',
  },
  'error.missing_verifier': {
    it: 'Errore di sicurezza nella connessione TikTok. Riprova.',
    en: 'Security error in TikTok connection. Please try again.',
  },
  'error.wrong_page': {
    it: 'Hai connesso la pagina Facebook sbagliata. Assicurati di connettere la pagina corretta.',
    en: 'You connected the wrong Facebook page. Make sure to connect the correct page.',
  },
  'error.wrong_account': {
    it: "Hai connesso l'account Instagram sbagliato. Assicurati di connettere l'account corretto.",
    en: 'You connected the wrong Instagram account. Make sure to connect the correct account.',
  },
  'error.unknown': {
    it: 'Errore sconosciuto. Contatta il supporto.',
    en: 'Unknown error. Please contact support.',
  },
  'error.connectFacebook': {
    it: 'Impossibile avviare la connessione a Facebook',
    en: 'Unable to start Facebook connection',
  },
  'error.connectTiktok': {
    it: 'Impossibile avviare la connessione a TikTok',
    en: 'Unable to start TikTok connection',
  },
  'error.connectInstagram': {
    it: 'Impossibile connettere Instagram',
    en: 'Unable to connect Instagram',
  },
  'error.disconnectMeta': {
    it: 'Impossibile disconnettere gli account Facebook/Instagram',
    en: 'Unable to disconnect Facebook/Instagram accounts',
  },
  'error.disconnectTiktok': {
    it: 'Impossibile disconnettere TikTok',
    en: 'Unable to disconnect TikTok',
  },
  'error.loadPages': {
    it: 'Impossibile caricare le pagine disponibili',
    en: 'Unable to load available pages',
  },
  'error.selectPage': {
    it: 'Impossibile selezionare la pagina',
    en: 'Unable to select page',
  },

  // ApprovalDashboardRoute
  'dashboard.loading': {
    it: 'Caricamento...',
    en: 'Loading...',
  },
  'dashboard.connectBanner.title': {
    it: 'Connetti i Tuoi Account Social',
    en: 'Connect Your Social Accounts',
  },
  'dashboard.connectBanner.body': {
    it: 'Collega Facebook e Instagram per pubblicare contenuti automaticamente. \u00c8 facile e sicuro.',
    en: 'Connect Facebook and Instagram to automatically publish content. Easy and secure.',
  },
  'portal.briefs.title': {
    it: 'In produzione',
    en: 'In production',
  },
  'portal.briefs.subtitle': {
    it: 'I servizi in corso di realizzazione',
    en: 'Shoots currently in production',
  },
  'portal.briefs.ideasOne': {
    it: 'idea',
    en: 'idea',
  },
  'portal.briefs.ideasMany': {
    it: 'idee',
    en: 'ideas',
  },
  'dashboard.review.title': {
    it: 'Da Revisionare',
    en: 'To Review',
  },
  'dashboard.review.subtitle': {
    it: 'Contenuti in attesa della tua approvazione',
    en: 'Content awaiting your approval',
  },
  'dashboard.review.ideas': {
    it: 'Revisiona Idee',
    en: 'Review Ideas',
  },
  'dashboard.review.ideasCount': {
    it: 'idee da revisionare',
    en: 'ideas to review',
  },
  'dashboard.review.ideasNone': {
    it: 'Nessuna idea in attesa',
    en: 'No ideas pending',
  },
  'dashboard.review.photos': {
    it: 'Revisiona Foto',
    en: 'Review Photos',
  },
  'dashboard.review.photosCount': {
    it: 'foto da revisionare',
    en: 'photos to review',
  },
  'dashboard.review.photosNone': {
    it: 'Nessuna foto in attesa',
    en: 'No photos pending',
  },
  'dashboard.review.posts': {
    it: 'Revisiona Post',
    en: 'Review Posts',
  },
  'dashboard.review.postsCount': {
    it: 'post da revisionare',
    en: 'posts to review',
  },
  'dashboard.review.postsNone': {
    it: 'Nessun post in attesa',
    en: 'No posts pending',
  },
  'dashboard.review.reels': {
    it: 'Revisiona Reel',
    en: 'Review Reels',
  },
  'dashboard.review.reelsCount': {
    it: 'reel da revisionare',
    en: 'reels to review',
  },
  'dashboard.review.reelsNone': {
    it: 'Nessun reel in attesa',
    en: 'No reels pending',
  },
  'dashboard.library.title': {
    it: 'Libreria e Contenuti',
    en: 'Library and Content',
  },
  'dashboard.library.subtitle': {
    it: 'Esplora e gestisci i tuoi media',
    en: 'Explore and manage your media',
  },
  'dashboard.library.allPhotos': {
    it: 'Tutte le Foto',
    en: 'All Photos',
  },
  'dashboard.library.allReels': {
    it: 'Tutte le Reel',
    en: 'All Reels',
  },
  'dashboard.library.viewAll': {
    it: 'Visualizza la libreria completa',
    en: 'View full library',
  },
  'dashboard.library.upload': {
    it: 'Carica Media',
    en: 'Upload Media',
  },
  'dashboard.library.uploadSub': {
    it: 'Carica foto o video',
    en: 'Upload photos or videos',
  },
  'dashboard.planning.title': {
    it: 'Report',
    en: 'Reporting',
  },
  'dashboard.planning.subtitle': {
    it: 'Analisi e risultati',
    en: 'Analytics and results',
  },
  'dashboard.planning.grid': {
    it: 'Planning',
    en: 'Planning',
  },
  'dashboard.planning.gridSub': {
    it: 'Rivedi la griglia di post proposti',
    en: 'Review the grid of proposed posts',
  },
  'dashboard.planning.report': {
    it: 'Report Social Media',
    en: 'Social Media Report',
  },
  'dashboard.planning.reportSub': {
    it: 'Performance e migliori post',
    en: 'Performance and top posts',
  },
  'dashboard.social.title': {
    it: 'I Tuoi Account Social',
    en: 'Your Social Accounts',
  },
  'dashboard.social.subtitle': {
    it: 'Gestisci le tue connessioni',
    en: 'Manage your connections',
  },
  'dashboard.social.notConnected': {
    it: 'Non connesso',
    en: 'Not connected',
  },
  'dashboard.social.connected': {
    it: 'Connesso',
    en: 'Connected',
  },
  'dashboard.social.inactive': {
    it: 'Non attivo',
    en: 'Not active',
  },
  'dashboard.social.manage': {
    it: 'Gestisci Connessioni',
    en: 'Manage Connections',
  },
  'dashboard.social.connect': {
    it: 'Connetti Account',
    en: 'Connect Accounts',
  },
  'dashboard.notifications.title': {
    it: 'Notifiche',
    en: 'Notifications',
  },
  'dashboard.notifications.subtitle': {
    it: 'Avvisi sui contenuti da approvare',
    en: 'Alerts for content awaiting approval',
  },
  // Creator magic-link view (on-site photographer today; video editor later)
  'creator.tabs.brief': {
    it: 'Brief',
    en: 'Brief',
  },
  'creator.tabs.ideas': {
    it: 'Idee',
    en: 'Ideas',
  },
  'creator.ideas.filter.all': {
    it: 'Tutte',
    en: 'All',
  },
  'creator.ideas.filter.draft': {
    it: 'Bozze',
    en: 'Draft',
  },
  'creator.ideas.filter.pending': {
    it: 'In attesa',
    en: 'Pending',
  },
  'creator.ideas.filter.approved': {
    it: 'Approvate',
    en: 'Approved',
  },
  'creator.ideas.filter.ready': {
    it: 'Pronte',
    en: 'Ready',
  },
  'creator.ideas.empty': {
    it: 'Nessuna idea in questo stato.',
    en: 'No ideas in this status yet.',
  },
  'creator.ideas.loadError': {
    it: 'Impossibile caricare le idee.',
    en: 'Failed to load ideas.',
  },
  'creator.brief.loadError': {
    it: 'Impossibile caricare il brief.',
    en: 'Failed to load brief.',
  },
  'creator.brief.empty': {
    it: 'Nessun brief attivo per questo cliente.',
    en: 'No active brief for this client.',
  },
  'creator.brief.untitled': {
    it: 'Brief senza titolo',
    en: 'Untitled brief',
  },
  'creator.brief.status': {
    it: 'Stato',
    en: 'Status',
  },
  'creator.brief.upload': {
    it: 'Carica media',
    en: 'Upload media',
  },
  'creator.brief.notes': {
    it: 'Note',
    en: 'Notes',
  },
  'creator.brief.notesEmpty': {
    it: 'Ancora nessuna nota.',
    en: 'No notes yet.',
  },
  'creator.brief.notePlaceholder': {
    it: 'Aggiungi una nota per il team...',
    en: 'Add a note for the team...',
  },
  'creator.brief.addNote': {
    it: 'Aggiungi',
    en: 'Add',
  },
  'creator.brief.ideas': {
    it: 'Idee collegate',
    en: 'Linked ideas',
  },
  'creator.brief.ideasEmpty': {
    it: 'Nessuna idea collegata a questo brief.',
    en: 'No ideas linked to this brief yet.',
  },
  'creator.brief.shotList': {
    it: 'Lista scatti',
    en: 'Shot list',
  },
  'creator.brief.back': {
    it: 'Tutti i brief',
    en: 'All briefs',
  },
  'creator.brief.events': {
    it: 'Eventi',
    en: 'Events',
  },
  'creator.brief.contextEmpty': {
    it: 'Nessun contesto per questo brief.',
    en: 'No context for this brief yet.',
  },
  'creator.idea.upload': {
    it: 'Carica',
    en: 'Upload',
  },
  'creator.briefs.empty': {
    it: 'Nessun brief in produzione',
    en: 'No briefs in production',
  },
  'creator.briefs.loadError': {
    it: 'Impossibile caricare i brief',
    en: 'Failed to load briefs',
  },
  'creator.briefs.idea': {
    it: 'idea',
    en: 'idea',
  },
  'creator.briefs.ideas': {
    it: 'idee',
    en: 'ideas',
  },
  'creator.menu.open': {
    it: 'Apri menu',
    en: 'Open menu',
  },
  'creator.menu.close': {
    it: 'Chiudi menu',
    en: 'Close menu',
  },
  'creator.header.logout': {
    it: 'Esci',
    en: 'Log out',
  },
  'creator.session.expiredTitle': {
    it: 'Sessione scaduta',
    en: 'Session expired',
  },
  'creator.session.expiredDescription': {
    it: 'Il link di accesso e scaduto. Richiedine uno nuovo per continuare.',
    en: 'Your access link has expired. Request a new one to continue.',
  },
  'client.trail.dashboard': {
    it: 'Dashboard',
    en: 'Dashboard',
  },
  'idea.sources': {
    it: 'Fonti',
    en: 'Sources',
  },
  'idea.section.concept': {
    it: 'Concept',
    en: 'Concept',
  },
  'idea.section.objective': {
    it: 'Obiettivo',
    en: 'Objective',
  },
  'idea.section.caption': {
    it: 'Caption',
    en: 'Caption',
  },
  'idea.section.voiceover_script': {
    it: 'Script voiceover',
    en: 'Voiceover Script',
  },
  'idea.section.storyboard': {
    it: 'Storyboard',
    en: 'Storyboard',
  },
  'client.menu.open': {
    it: 'Apri menu',
    en: 'Open menu',
  },
  'client.menu.close': {
    it: 'Chiudi menu',
    en: 'Close menu',
  },
  'client.header.logout': {
    it: 'Esci',
    en: 'Log out',
  },
  // PortalPlanRoute and its dashboard card (finance-pricing target)
  'plan.title': {
    it: 'Il tuo piano',
    en: 'Your plan',
  },
  'plan.subtitle': {
    it: 'Cosa facciamo per te e quanto costa.',
    en: 'What we do for you and what it costs.',
  },
  'plan.empty': {
    it: 'Il tuo piano non è ancora attivo. Ti scriviamo noi appena è pronto.',
    en: 'Your plan is not active yet. We will write to you as soon as it is ready.',
  },
  'plan.current': {
    it: 'In corso',
    en: 'In progress',
  },
  'plan.note': {
    it: 'Prezzi IVA esclusa. Per cambiare il piano scrivici: lo aggiorniamo insieme.',
    en: 'Prices exclude VAT. To change your plan, write to us and we update it together.',
  },
  'plan.denied': {
    it: 'Il piano è visibile solo ai referenti del cliente.',
    en: "The plan is shown to the client's own contacts only.",
  },
  'plan.error': {
    it: 'Non siamo riusciti a caricare il piano.',
    en: 'We could not load the plan.',
  },
  'plan.retry': {
    it: 'Riprova',
    en: 'Retry',
  },
  'dashboard.plan.title': {
    it: 'Il tuo piano',
    en: 'Your plan',
  },
  'dashboard.plan.subtitle': {
    it: 'Servizi e prezzi concordati',
    en: 'Services and agreed prices',
  },
  'dashboard.plan.open': {
    it: 'Vedi il piano',
    en: 'See your plan',
  },
  'dashboard.plan.openSub': {
    it: 'Cosa facciamo e quanto costa',
    en: 'What we do and what it costs',
  },
  'dashboard.details.title': {
    it: 'Dettagli',
    en: 'Details',
  },
  'dashboard.details.subtitle': {
    it: 'Le informazioni del tuo profilo',
    en: 'Your profile information',
  },
  'dashboard.details.bio': {
    it: 'Bio',
    en: 'Bio',
  },
  'dashboard.details.bioSub': {
    it: 'Le bio dei tuoi profili social',
    en: 'Your social profile bios',
  },
  'client.bio.edit': {
    it: 'Modifica',
    en: 'Edit',
  },
  'client.bio.loadError': {
    it: 'Impossibile caricare la bio. Riprova più tardi.',
    en: "Couldn't load the bio. Try again later.",
  },
  'tasks.visibleToClient': {
    it: 'Visibile al cliente',
    en: 'Visible to the client',
  },
  'client.menu.tasks': {
    it: 'Attività',
    en: 'Tasks',
  },
  'client.tasks.title': {
    it: 'Attività',
    en: 'Tasks',
  },
  'client.tasks.open': {
    it: 'Da fare',
    en: 'To do',
  },
  'client.tasks.done': {
    it: 'Fatte',
    en: 'Done',
  },
  'client.tasks.emptyOpen': {
    it: 'Nessuna attività da fare.',
    en: 'Nothing to do.',
  },
  'client.tasks.emptyDone': {
    it: 'Nessuna attività completata.',
    en: 'No completed tasks yet.',
  },
  'client.tasks.loadError': {
    it: 'Impossibile caricare le attività.',
    en: "Couldn't load the tasks.",
  },
  'client.tasks.movedToTeam': {
    it: "L'attività è passata al team e non è più visibile qui.",
    en: 'The task went to the team and no longer shows here.',
  },
  'dashboard.review.tasks': {
    it: 'Attività',
    en: 'Tasks',
  },
  'dashboard.review.tasksCount': {
    it: 'attività da fare',
    en: 'tasks to do',
  },
  'dashboard.review.tasksNone': {
    it: 'Nessuna attività da fare',
    en: 'No tasks to do',
  },
} as const;

type TranslationKey = keyof typeof translations;

export function useLocale() {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get('lang');
  const locale: Locale = lang === 'en' ? 'en' : 'it';

  function t(key: TranslationKey): string {
    const entry = translations[key];
    return entry[locale];
  }

  function tDynamic(key: string, fallback: TranslationKey): string {
    const entry = translations[key as TranslationKey];
    if (entry) return entry[locale];
    return translations[fallback][locale];
  }

  return { t, tDynamic, locale };
}
